<template>
  <span class="nc-cell-field nc-null uppercase">{{ $t('general.null') }}</span>
</template>
